import { UseDataQuery } from '../../../hooks/useDataQuery/dataQuery.types';

export const getFindLatestHighlightsKey = (limit: number): UseDataQuery['queryKey'] => [
  'highlights-latest',
  undefined,
  { limit },
];

export const getFindHighlightsKey = (): UseDataQuery['queryKey'] => ['highlights'];

export const getHighlightKey = (highlightId: string): UseDataQuery['queryKey'] => [
  'highlights',
  undefined,
  { highlightId },
];
